import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';

function InlineLabel(_a) {
  var {
      id,
      className,
      children
    } = _a,
    rest = __rest(_a, ["id", "className", "children"]);
  return /*#__PURE__*/React.createElement("span", Object.assign({
    id: "inline-label-".concat(id),
    className: className
  }, rest), children);
}
InlineLabel.displayName = 'InlineLabel';
InlineLabel.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export { InlineLabel, InlineLabel as default };
